var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,9.8C21.7,9.1,22,8.3,22,7.5C22,4.4,17.6,2,12,2S2,4.4,2,7.5c0,0.8,0.3,1.6,0.8,2.2C2.3,10.4,2,11.2,2,12 s0.3,1.6,0.8,2.2C2.3,14.9,2,15.7,2,16.5C2,19.6,6.4,22,12,22s10-2.4,10-5.5c0-0.8-0.3-1.6-0.8-2.2c0.5-0.7,0.8-1.4,0.8-2.2 S21.7,10.4,21.2,9.8z M12,20c-4.7,0-8-1.8-8-3.5c0-0.3,0.1-0.6,0.3-0.9c1.8,1.2,4.5,1.9,7.7,1.9s5.9-0.8,7.7-1.9 c0.2,0.3,0.3,0.6,0.3,0.9C20,18.2,16.7,20,12,20z M19.7,12.9c-0.3,0.5-0.9,0.9-1.7,1.3c-1.4,0.7-3.5,1.2-6,1.2S7.4,15,6,14.2 c-0.8-0.4-1.3-0.8-1.7-1.3C4.1,12.6,4,12.3,4,12s0.1-0.6,0.3-0.9c0.5,0.4,1.2,0.7,1.9,0.9c1.6,0.6,3.6,1,5.8,1s4.2-0.4,5.8-1 c0.7-0.3,1.3-0.6,1.9-0.9c0.2,0.3,0.3,0.6,0.3,0.9S19.9,12.6,19.7,12.9z M19.7,8.4c-0.3,0.5-0.9,0.9-1.7,1.3 c-1.4,0.7-3.5,1.2-6,1.2s-4.6-0.5-6-1.2C5.2,9.4,4.7,8.9,4.3,8.4C4.1,8.1,4,7.8,4,7.5C4,5.8,7.3,4,12,4s8,1.8,8,3.5 C20,7.8,19.9,8.1,19.7,8.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCosts);
export default __webpack_public_path__ + "static/media/icon-costs.da2697c291d0aff5a29b3c190cbb32c2.svg";
export { ForwardRef as ReactComponent };